module.exports = __webpack_public_path__ + "img/compage_main.9d039020.png";